// Lightweight inline markdown renderer for **bold** and *italic*.
// Returns an array of <p> elements with proper line breaks.
import React from 'react';

export const renderMarkdownText = (text) => {
  if (!text) return null;
  const lines = text.split('\n');
  return lines.map((line, lineIdx) => {
    const parts = [];
    let keyCounter = 0;
    const formatRegex = /(\*\*(.+?)\*\*|\*(.+?)\*)/g;
    let lastIndex = 0;
    let match;
    while ((match = formatRegex.exec(line)) !== null) {
      if (match.index > lastIndex) parts.push(line.substring(lastIndex, match.index));
      if (match[2]) parts.push(<strong key={`b-${lineIdx}-${keyCounter++}`}>{match[2]}</strong>);
      else if (match[3]) parts.push(<em key={`i-${lineIdx}-${keyCounter++}`}>{match[3]}</em>);
      lastIndex = match.index + match[0].length;
    }
    if (lastIndex < line.length) parts.push(line.substring(lastIndex));
    if (parts.length === 0) parts.push(line);
    return <p key={lineIdx} className={lineIdx > 0 ? 'mt-4' : ''}>{parts}</p>;
  });
};
